import React from 'react';
import PropTypes from "prop-types";
import {Checkbox} from "semantic-ui-react";
import MARVEL from "../../../common/utils/MarvelUrls";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {BillingOrgSortFields} from "../constants/BillingOrganizationsActionConstants";

export class BillingOrganizationsListRow extends React.Component {

    static propTypes = {
        organizationObject: PropTypes.object,
        organizationName: PropTypes.string,
        orgID: PropTypes.string,
        billingANumber: PropTypes.string,
        locationANumber: PropTypes.string,
        monthlyMinCommit: PropTypes.number,
        monthlyPlatformFee: PropTypes.number,
    }

    get billingOrgCheckbox() {
        return (
            <td className="low-width">
                <Checkbox disabled
                />
            </td>
        )
    }

    get billingOrgName() {
        const { organizationName, orgID, billingOrgSortKey } = this.props;
        let classnames = ""
        if (billingOrgSortKey === BillingOrgSortFields.NAME) {
            classnames += "current-sort"
        }
        return (
                <td className={classnames}>
                    <Link to={{pathname: MARVEL.BILLING.organizations + orgID}} key={orgID}>
                        <p>{organizationName}</p>
                    </Link>
                </td>

        )
    }

    get billingANumber() {
        const { billingANumber } = this.props;
        return (
            <td>
                {billingANumber}
            </td>
        )
    }

    get locationANumber() {
        const { locationANumber } = this.props;
        return (
            <td>
                {locationANumber}
            </td>
        )
    }

    get monthlyMinCommit() {
        const { monthlyMinCommit } = this.props;
        return (
            <td>
                {monthlyMinCommit}
            </td>
        )
    }

    get monthlyPlatformFee() {
        const { monthlyPlatformFee } = this.props;
        return (
            <td>
                {monthlyPlatformFee}
            </td>
        )
    }

    render() {

        return (
            <tr>
                {this.billingOrgCheckbox}
                {this.billingOrgName}
                {this.billingANumber}
                {this.locationANumber}
                {this.monthlyMinCommit}
                {this.monthlyPlatformFee}
            </tr>
        )
    }
}

const mapStateToProps = (state) => ({
    billingOrgSortKey: state.billing.organizations.billingOrgSortKey,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingOrganizationsListRow)
